import { Inject, Injectable } from "@angular/core";
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { AddNewBandResult, BandData, GetClientPriceBandsResult, GetJobPriceBandsResult, GetPriceBandsResult, PriceBandWithHistory } from "./bands-types";
import { ResultBase } from "@intranet/core/types";

@Injectable({
    providedIn: 'root',
})
export class BandsService {

    constructor(private _http: HttpClient,
        @Inject('BASE_URL') private originUrl: string
    ) {}


    test() {
        console.log('BandsService test');
    }

    addNewPriceBand(bandName: string, bandRate: number) : Observable<AddNewBandResult> {
        return this._http.post<AddNewBandResult>(`${this.originUrl}api/Band/AddNewPriceBand`, { bandName, bandRate });
        //return of({ success: false, error: 'Not Implemented'});
    }

    getPriceBands() : Observable<GetPriceBandsResult> {
        return this._http.get<GetPriceBandsResult>(`${this.originUrl}api/Band/GetPriceBands`);
    }
    getClientPriceBands(clientId: number) : Observable<GetClientPriceBandsResult> {
        return this._http.get<GetClientPriceBandsResult>(`${this.originUrl}api/Band/GetClientPriceBands/${clientId}`);
    }
    getJobPricebands(jobId: number) : Observable<GetJobPriceBandsResult> {
        return this._http.get<GetJobPriceBandsResult>(`${this.originUrl}api/Band/GetJobPriceBands/${jobId}`);
    }

    addClientPriceBands(clientId: number, startDate: Date, bands: BandData[])
        : Observable<ResultBase> {
        return this._http.post<ResultBase>(`${this.originUrl}api/Band/AddClientPriceBands`, { clientId, startDate, bands });
    }

    addJobPriceBands(jobId: number, startDate: Date, bands: BandData[])
        : Observable<ResultBase> {
        return this._http.post<ResultBase>(`${this.originUrl}api/Band/AddJobPriceBands`, { jobId, startDate, bands });
    }

    addGlobalPriceBands(startDate: Date, bands: BandData[])
        : Observable<ResultBase> {
        return this._http.post<ResultBase>(`${this.originUrl}api/Band/AddGlobalPriceBands`, { startDate, bands });
    }

    deleteClientPriceBands(clientId: number, startDate: Date) : Observable<ResultBase> {
        return this._http.post<ResultBase>(`${this.originUrl}api/Band/DeleteClientPriceBands`, { clientId, startDate });
    }

    deleteGlobalPriceBands(startDate: Date) : Observable<ResultBase> {
        return this._http.post<ResultBase>(`${this.originUrl}api/Band/DeleteGlobalPriceBands`, { startDate });
    }

    deleteJobPriceBands(jobId: number, startDate: Date) : Observable<ResultBase> {
        return this._http.post<ResultBase>(`${this.originUrl}api/Band/DeleteJobPriceBands`, { jobId, startDate });
    }
}